import { openDB } from 'idb';

/* Almacén local (IndexedDB) de conceptos, capturas y figuras pendientes de sincronizar */
const DB_NAME = 'generia-offline';
const DB_VERSION = 2;

const dbPromise = openDB(DB_NAME, DB_VERSION, {
  upgrade(db) {
    if (!db.objectStoreNames.contains('captures')) {
      const captures = db.createObjectStore('captures', { keyPath: 'id' });
      captures.createIndex('by_created', 'created_at');
      captures.createIndex('by_project', 'project_id');
    }
    if (!db.objectStoreNames.contains('figures')) {
      const figures = db.createObjectStore('figures', { keyPath: 'id' });
      figures.createIndex('by_created', 'created_at');
      figures.createIndex('by_capture', 'capture_id');
      figures.createIndex('by_project', 'project_id');
    }
    if (!db.objectStoreNames.contains('concepts')) {
      const concepts = db.createObjectStore('concepts', { keyPath: 'id' });
      concepts.createIndex('by_created', 'created_at');
      concepts.createIndex('by_project', 'project_id');
    }
  },
});

const sortByCreated = (items) => items.sort((a, b) => (a.created_at < b.created_at ? -1 : 1));

export const offlineDb = {
  // Conceptos: { id, project_id, payload, created_at, lastError }
  async putConcept(record) {
    return (await dbPromise).put('concepts', record);
  },
  async getConcept(id) {
    return (await dbPromise).get('concepts', id);
  },
  async getAllConcepts() {
    return sortByCreated(await (await dbPromise).getAll('concepts'));
  },
  async getConceptsForProject(projectId) {
    return sortByCreated(await (await dbPromise).getAllFromIndex('concepts', 'by_project', projectId));
  },
  async deleteConcept(id) {
    return (await dbPromise).delete('concepts', id);
  },

  // Capturas: { id, project_id, payload, created_at, synced, lastError }
  async putCapture(record) {
    return (await dbPromise).put('captures', record);
  },
  async getCapture(id) {
    return (await dbPromise).get('captures', id);
  },
  async getAllCaptures() {
    return sortByCreated(await (await dbPromise).getAll('captures'));
  },
  async deleteCapture(id) {
    return (await dbPromise).delete('captures', id);
  },

  // Figuras: { id, capture_id, project_id, payload, created_at, lastError }
  async putFigure(record) {
    return (await dbPromise).put('figures', record);
  },
  async getAllFigures() {
    return sortByCreated(await (await dbPromise).getAll('figures'));
  },
  async getFiguresForCapture(captureId) {
    return (await dbPromise).getAllFromIndex('figures', 'by_capture', captureId);
  },
  async deleteFigure(id) {
    return (await dbPromise).delete('figures', id);
  },

  // Conteos para el indicador y para estimar numeración local
  async countPending() {
    const db = await dbPromise;
    const concepts = await db.count('concepts');
    const captures = (await db.getAll('captures')).filter((c) => !c.synced).length;
    const figures = await db.count('figures');
    return { concepts, captures, figures, total: concepts + captures + figures };
  },
  async countPendingForProject(projectId) {
    const db = await dbPromise;
    const captures = (await db.getAllFromIndex('captures', 'by_project', projectId)).filter((c) => !c.synced).length;
    const figures = await db.countFromIndex('figures', 'by_project', projectId);
    return { captures, figures };
  },
};
